<script lang="ts">
	import { range } from 'lodash-es';
	import ArrowButton from './ArrowButton.svelte';
	import PageButton from './PageButton.svelte';

	import { setContext } from 'svelte';
	import { writable } from 'svelte/store';
	import DotsPlaceholder from './DotsPlaceholder.svelte';

	export let pageCount = 24;
	export let currentPage = 1;
	let className = '';
	export { className as class };
	export let contentClass = '';
	export let paginationClass = '';

	const currentPageStore = writable(currentPage);

	const goPrev = () => {
		currentPage = currentPage - 1;
	};

	const goNext = () => {
		currentPage = currentPage + 1;
	};
	const setCurrentPage = (page: number) => {
		currentPage = page;
	};

	const isWithinNToFirstPage = (maxPaginationItems: number, currentPage: number) => {
		const n = Math.floor(maxPaginationItems / 2);
		return currentPage <= n;
	};
	const isWithinNToLastPage = (
		maxPaginationItems: number,
		currentPage: number,
		pageCount: number
	) => {
		const n = Math.floor(maxPaginationItems / 2);
		return currentPage > pageCount - n;
	};

	setContext('pagination', {
		currentPage: currentPageStore,
		setCurrentPage
	});

	$: currentPageStore.set(currentPage);
</script>

<div class={className}>
	<div class={contentClass}>
		<slot />
	</div>

	<!-- Mobile -->
	{#if pageCount > 1}
		<div
			class="flex lg:hidden items-center justify-center pt-7.5 md:gap-2 gap-3 my-auto {paginationClass}"
		>
			<ArrowButton
				direction="back"
				on:click={goPrev}
				hidden={currentPage === 1}
				aria-label="Zur vorherigen Seite"
				aria-disabled={currentPage === 1}
			/>

			{#if pageCount <= 5}
				{#each range(1, pageCount + 1) as page}
					<PageButton pageNumber={page} ariaLabel={`Gehe zu Seite ${page}`} />
				{/each}
			{:else}
				<!-- 1 2 3 ... n -->
				{#if isWithinNToFirstPage(5, currentPage)}
					{#each range(1, 4) as page}
						<PageButton pageNumber={page} ariaLabel={`Gehe zu Seite ${page}`} />
					{/each}
					<DotsPlaceholder />
					<PageButton pageNumber={pageCount} ariaLabel={`Gehe zu Seite ${pageCount}`} />
				{/if}
				<!-- 1 ... n-2 n-1 n -->
				{#if isWithinNToLastPage(5, currentPage, pageCount)}
					<PageButton pageNumber={1} ariaLabel={`Gehe zu Seite 1`} />
					<DotsPlaceholder />
					{#each range(pageCount - 2, pageCount + 1) as page}
						<PageButton pageNumber={page} ariaLabel={`Gehe zu Seite ${page}`} />
					{/each}
				{/if}
				<!-- 1 ... x ... n -->
				{#if !isWithinNToFirstPage(5, currentPage) && !isWithinNToLastPage(5, currentPage, pageCount)}
					<PageButton pageNumber={1} ariaLabel={`Gehe zu Seite 1`} />
					<DotsPlaceholder />
					{#each range(currentPage, currentPage + 1) as page}
						<PageButton pageNumber={page} ariaLabel={`Gehe zu Seite ${page}`} />
					{/each}
					<DotsPlaceholder />
					<PageButton pageNumber={pageCount} ariaLabel={`Gehe zu Seite ${pageCount}`} />
				{/if}
			{/if}
			<ArrowButton
				direction="forward"
				on:click={goNext}
				hidden={currentPage === pageCount}
				aria-label="Zur nächsten Seite"
				aria-disabled={currentPage === pageCount}
			/>
		</div>
	{/if}

	<!-- Desktop -->
	{#if pageCount > 1}
		<div class="hidden lg:flex justify-center pt-7.5 gap-3 my-auto {paginationClass}">
			<ArrowButton
				direction="back"
				on:click={goPrev}
				hidden={currentPage === 1}
				aria-label="Zur vorherigen Seite"
				aria-disabled={currentPage === 1}
			/>

			{#if pageCount <= 11}
				{#each range(1, pageCount + 1) as page}
					<PageButton pageNumber={page} ariaLabel={`Gehe zu Seite ${page}`} />
				{/each}
			{:else}
				<!-- 1 2 3 ... n -->
				{#if isWithinNToFirstPage(11, currentPage)}
					{#each range(1, 10) as page}
						<PageButton pageNumber={page} ariaLabel={`Gehe zu Seite ${page}`} />
					{/each}

					<DotsPlaceholder />
					<PageButton pageNumber={pageCount} ariaLabel={`Gehe zu Seite ${pageCount}`} />
				{/if}
				<!-- 1 ... n-2 n-1 n -->
				{#if isWithinNToLastPage(11, currentPage, pageCount)}
					<PageButton pageNumber={1} />
					<DotsPlaceholder />
					{#each range(pageCount - 8, pageCount + 1) as page}
						<PageButton pageNumber={page} ariaLabel={`Gehe zu Seite ${page}`} />
					{/each}
				{/if}
				<!-- 1 ... x ... n -->
				{#if !isWithinNToFirstPage(11, currentPage) && !isWithinNToLastPage(11, currentPage, pageCount)}
					<PageButton pageNumber={1} />
					<DotsPlaceholder />
					{#each range(currentPage - 3, currentPage + 4) as page}
						<PageButton pageNumber={page} ariaLabel={`Gehe zu Seite ${page}`} />
					{/each}
					<DotsPlaceholder />
					<PageButton pageNumber={pageCount} ariaLabel={`Gehe zu Seite ${pageCount}`} />
				{/if}
			{/if}
			<ArrowButton
				direction="forward"
				on:click={goNext}
				hidden={currentPage === pageCount}
				aria-label="Zur nächsten Seite"
				aria-disabled={currentPage === pageCount}
			/>
		</div>
	{/if}
</div>
